import React, { useEffect, useState } from "react";
import Humanize from "humanize-plus";

/**
 * basado en al extension del archivo determina si se puede mostrar preview del mismo (si son imagenes)
 * o mostrar un icono representativo del archivo
 * @param archivo file
 * @param hash hash
 * @param local is local (cuando aun no se sube al server)
 * @returns {[string, boolean]|*}
 */
const get_thumbnail_src = (archivo, local = false) => {
    // show only icon if file or image
    if (archivo.indexOf(".pdf") > 0) {
        return ["/img/pdf.png", true];
    } else if (archivo.indexOf(".doc") > 0) {
        return ["/img/doc.png", false];
    } else if (archivo.indexOf(".txt") > 0) {
        return ["/img/txt.png", false];
    } else if (archivo.indexOf(".xls") > 0) {
        return ["/img/xls.png", false];
    } else if (archivo.indexOf(".csv") > 0) {
        return ["/img/csv.png", false];
    }

    return local ? ["/img/file.png", false] : [archivo, true];
};

export const Thumbnail = ({ archivo, onClose, edit, modalPreview }) => {
    let fileSrc = archivo;
    let [thumbnailSrc, isModal] = get_thumbnail_src(archivo);

    return (
        <div className="thumbnail">
            <div className="image">
                {isModal ? (
                    <div onClick={() => modalPreview(fileSrc, archivo)}>
                        <img
                            className={thumbnailSrc.includes("/img/") ? "default" : ""}
                            src={thumbnailSrc}
                            alt={`img-${archivo}`}
                        />
                    </div>
                ) : (
                    <a href={fileSrc} target="_blank" rel="noopener noreferrer">
                        <img
                            className={thumbnailSrc.includes("/img/") ? "default" : ""}
                            src={thumbnailSrc}
                            alt={`img-${archivo}`}
                        />
                    </a>
                )}
            </div>
            <div className="info" title={archivo}>
                {archivo}
            </div>
            {onClose && (
                <button type="button" className="close" onClick={onClose} disabled={!edit}>
                    <span aria-hidden="true">&times;</span>
                </button>
            )}
        </div>
    );
};

export const ThumbnailLocal = ({ archivo, onClose }) => {
    let [thumbnailSrc, setThumbnailSrc] = useState(get_thumbnail_src(archivo.name, true)[0]);

    useEffect(() => {
        if (thumbnailSrc === "/img/file.png") {
            let reader = new FileReader();
            reader.onloadend = () => {
                setThumbnailSrc(reader.result);
            };

            reader.readAsDataURL(archivo);
        }

        return () => {
            // https://react-dropzone.js.org/#section-previews
            URL.revokeObjectURL(thumbnailSrc);
        };
    }, [archivo]);

    return (
        <div className="thumbnail">
            <div className="image text-center d-flex flex-column justify-content-center align-items-center">
                <img src={thumbnailSrc} alt={`img-${archivo.name}`} className="st-155" />
                <span className={"text-center text-white pt-1"}>{`(${Humanize.fileSize(archivo.size)})`}</span>
            </div>
            {onClose && (
                <button type="button" className="close" onClick={onClose}>
                    <span aria-hidden="true">&times;</span>
                </button>
            )}
        </div>
    );
};
